import React from "react";
import { View, StyleSheet } from "react-native";
import ChipSelector, { ChipOption } from "../../../common/form/ChipSelect/ChipSelector";
import CustomDropdown from "../../../common/general/CustomDropDown/CustomDropdown";
import CustomText from "../../../common/general/CustomText/CustomText";
import { spacing, colors } from "../../../../styles/design-system";
import { useTranslation } from "react-i18next";

interface Value {
  motivations: string[];
  semesterGoal: string;
}

interface Props {
  value: Value;
  onChange: (v: Value) => void;
}

export default function MotivationEditor({ value, onChange }: Props) {
  const { t } = useTranslation();

  const motivationOptions: ChipOption[] = [
    { key: "better_grades", value: "Better Grades" },
    { key: "deep_understanding", value: "Deep Understanding" },
    { key: "more_confidence", value: "More Confidence" },
    { key: "learning_faster", value: "Learning Faster" },
  ];

  const goalOptions = [
    { value: "pass_finals", label: t("text.companion_onboarding_goal_pass_finals") },
    { value: "improve_gpa", label: t("text.companion_onboarding_goal_improve_gpa") },
    { value: "complete_prerequisites", label: t("text.companion_onboarding_goal_complete_prerequisites") },
    { value: "stay_on_track", label: t("text.companion_onboarding_goal_stay_on_track") },
  ];

  return (
    <View style={styles.container}>
      <CustomText
        style={{ color: colors.grey[500], marginBottom: spacing.xxs }}
        useTranslationText={false}
        text="WHAT DRIVES YOU?"
        size="xs"
        weight="bold"
      />
      <View style={{ marginBottom: spacing.lg }}>
        <ChipSelector
          options={motivationOptions}
          selectedKeys={value?.motivations ?? []}
          onSelectionChange={(v) => onChange({ ...value, motivations: v })}
          multiSelect
        />
      </View>

      <CustomText
        style={{ color: colors.grey[500], marginBottom: spacing.xxs }}
        useTranslationText={false}
        text="WHAT IS YOUR FOCUS THIS SEMESTER?"
        size="xs"
        weight="bold"
      />
      <View style={{ position: "relative", zIndex: 9999 }}>
        <CustomDropdown
          options={goalOptions}
          value={value?.semesterGoal ?? ""}
          onChange={(v) => onChange({ ...value, semesterGoal: v })}
          placeholder="Select a goal"
          containerStyle={{ width: "100%", marginBottom: spacing.xxs }}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: spacing.xxs,
  },
});
